module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 7
// module chunks = 0 1